/* eslint-disable */
import React from 'react'
import classes from './FullWidthECGPreview.css'
import Beat from './Beats';
import Grid from './Grid'
import Waveform from './Waveform'
import * as Lib from './previewConstant'

export const FullWidthECGPreview = props => {

    const {
        height = 2 * Lib.MV_BANDWIDTH * Lib.PX_PER_MV+1,
        inverted = false,
        sample = null,
        beats = [],
        ecgTitle = null,
        seconds = 6,
        width = seconds * Lib.PX_PER_SECOND,
        classApplied
    } = props

  return (
    // <div className={classes.eKGPreview}>
      <svg width={width} height={height} className={classes.previewGrid} style={ classApplied ? {marginBottom: '-135px'} : ''}>
        {ecgTitle && <text x="5" y="35" className={classes.LeadTitle}>{ecgTitle}</text>}
        {beats != [] && beats.map(beat => 
            <Beat 
                key ={beat}
                capsule={false}
                height={height}
                samples={sample}
                inverted={inverted}
                index={beat[0]}
                type={beat[1]}
            />
        )}
        <g transform="translate(0,0)">
          <Grid
            renderSmallGrid={false}
            rowSeconds={seconds}
            stripWidthPx={width}
            height={height}
          />
          <Waveform
            height={height}
            samples={sample}
            inverted={inverted}
            mainsFreq={60}
          />
        </g>
      </svg>
    // </div>
  )
}

export default FullWidthECGPreview



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/components/FullECGPreview/FullWidthECGPreview.jsx